import { render, staticRenderFns } from "./OfacList.vue?vue&type=template&id=a119a390"
import script from "./OfacList.vue?vue&type=script&lang=js"
export * from "./OfacList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports